<template>
  <Plugin
    from="m/platform/plugin/common"
    name="advert-banner"
    :props="{}"
    :emit="{
      onReady: updateDialog,
    }"
  />
</template>
<script setup>
import { usePluginReadyEmit } from "app-core";
import { onMounted } from "vue";
const [showDialog, updateDialog] = usePluginReadyEmit();

onMounted(() => {
  showDialog({
    code: "HOME_ALERT",
  });
});
</script>
